"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD_EXPENSE = void 0;
var ADD_EXPENSE = {
  BUTTON__NEXT_STEP: 'addExpense-button-nextStep',
  BUTTON__PREV_STEP: 'addExpense-button-prevStep',
  INFO: {
    INPUT__TIME: 'addExpenseInfo-input-time',
    BUTTON__EXPENSE_TYPE: 'addExpenseInfo-button-expenseType',
    BUTTON__DATE: 'addExpenseInfo-button-date',
    TEXTAREA__NOTE: 'addExpenseInfo-textarea-note'
  },
  DETAILS: {
    INPUT__MONEY_SPENT: 'addExpenseDetails-input-moneySpent',
    BUTTON__TAX_RATE: 'addExpenseDetails-button-taxRate',
    BUTTON__UPLOAD_RECEIPT: 'addExpenseDetails-button-uploadReceipt'
  },
  OVERVIEW: {
    TEXT__TYPE: 'addExpenseOverview-span-type',
    TEXT__DATE_TIME: 'addExpenseOverview-span-dateTime',
    TEXT__NOTE: 'addExpenseOverview-span-note',
    TEXT__MONEY_SPENT: 'addExpenseOverview-span-moneySpent',
    TEXT__TAX: 'addExpenseOverview-span-tax',
    BUTTON__EDIT_INFO: 'addExpenseOverview-button-editInfo',
    BUTTON__EDIT_DETAILS: 'addExpenseOverview-button-editDetails',
    IMG__RECEIPT: 'addExpenseOverview-img-receipt'
  }
};
exports.ADD_EXPENSE = ADD_EXPENSE;